import { BrowserRouter as Router, Redirect } from 'react-router-dom';
import Routes from '../Routes/Routes';
import LoginPolicyNumber from '../../containers/LoginFlow/LoginPolicyNumber/LoginPolicyNumber';
import LoginToImpersonateClient from '../../containers/Login/LoginToImpersonateClient';
import VerifyEmail from '../../containers/LoginFlow/VerifyEmail/VerifyEmail';
import { AuthFlowProvider } from '../../shared/context/auth-flow-context';
import SetPassword from '../../containers/LoginFlow/Password/SetPassword';
import LoginPassword from '../../containers/LoginFlow/Password/LoginPassword';
import ResetPassword from '../../containers/LoginFlow/Password/ResetPassword';
import RemindPolicyNumber from '../../containers/LoginFlow/RemindPolicyNumber/RemindPolicyNumber';

export default function NonAuthenticatedApp() {
  const routes = [
    {
      id: 1,
      path: '/resetpassword',
      exact: true,
      component: <ResetPassword />
    },
    {
      id: 2,
      path: '/impersonateClient',
      exact: true,
      component: <LoginToImpersonateClient />
    },
    {
      id: 4,
      path: '/verify-email',
      exact: true,
      component: <VerifyEmail />
    },
    {
      id: 5,
      path: '/set-password',
      exact: true,
      component: <SetPassword />
    },
    {
      id: 6,
      path: '/login-password',
      exact: true,
      component: <LoginPassword />
    },
    {
      id: 7,
      path: '/remind-policyNumber',
      exact: true,
      component: <RemindPolicyNumber />
    },
    {
      id: 3,
      path: '/',
      exact: false,
      component: (
        <>
          <Redirect to="/" />
          <LoginPolicyNumber />
        </>
      )
    }
  ];

  return (
    <Router>
      <AuthFlowProvider>
        <Routes routes={routes} />
      </AuthFlowProvider>
    </Router>
  );
}
